import React from 'react';
import { Box } from '@mui/material';
import { useAddressLogic } from '@europrocurement/flexy-components/hooks/useAddressLogic';
import type { PrescripteurApi } from '@europrocurement/l2d-domain';
import { UserStructureMainDetailsForm } from './fragments/UserStructureMainDetailsForm';
import { UserStructureAddressDetailsForm } from './fragments/UserStructureAddressDetailsForm';

export type UserStructureDetailsFormProps = {
    prescriber?: PrescripteurApi;
};

/**
 * Composant principal du formulaire de détails de structure utilisateur.
 */
export const UserStructureDetailsForm: React.FunctionComponent<UserStructureDetailsFormProps> =
    function ({ prescriber }) {
        const { mainAddress, billingAddress, isBillingAddressSame, hasBillingAddress } =
            useAddressLogic(prescriber);

        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <UserStructureMainDetailsForm prescriber={prescriber} />

                <UserStructureAddressDetailsForm
                    address={mainAddress}
                    isBillingAddressSame={isBillingAddressSame}
                />

                {billingAddress && hasBillingAddress && !isBillingAddressSame && (
                    <UserStructureAddressDetailsForm
                        address={billingAddress}
                        isBillingAddress
                    />
                )}
            </Box>
        );
    };
